import { MediaMatrixSystemDefaults } from "@/types/sv-data/media-matrix/Constants";
import { SiteMonitorCamerasState } from "./types";

export function getDefaultState(): SiteMonitorCamerasState {
    return {
        layoutIndex: MediaMatrixSystemDefaults.LAYOUT_INDEX,
        layouts: MediaMatrixSystemDefaults.LAYOUTS,
		userLastLayoutIndex: null,
        matrixContents: {},
        matrixPushContents: {},
        mediaMatrixCameras: Array(16),
        mediaMatrixClips: [],
        mediaMatrixLayers: [],
        mediaMatrixLastChanged: 0,
        deviceControllerCameras: [],
        deviceControllerOutputs: [],
        deviceControllerClips: [],
        deviceControllerAudioDevices: [],
        areaCameras: [],
        searchedCameras: [],
        searchedOutputs: [],
        mediaMatrixIsNew: false,
        fetchingMatrix: false,
        mediaMatrixFilter: "",
        mediaMatrixEventId: null,
        awaitingCamera: null,
        awaitingClip: null,
        saveLink: false,
        linkRecord: null,
        requiresEventDetails: false,
        highlightCellIndices: [],
        waitingForEvent: false,
        shownAuditClips: [],
		areaOutputs: [],
		areaOutputCount: 0,
		areaCameraCount: 0,
		searchedCameraCount: 0,
		searchedGroupCameraCount: 0,
		searchedOutputCount: 0,
		areaAudioDevices: [],
		areaAudioDevicesCount: 0,
		nearbyAudioDevices: [],
		filteredAreaAudioDevicesCount: 0,
    }
}
